import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { DOCUMENT, inject, Injector } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { AppRoutes } from '../app/app.routes';
import { environment } from '../environments/environment';

const XSRF_COOKIE = 'XSRF-TOKEN';
const XSRF_HEADER = 'X-XSRF-TOKEN';

function readCookie(doc: Document, name: string): string | null {
  const match = doc.cookie
    .split('; ')
    .find((row) => row.startsWith(`${name}=`));
  return match ? decodeURIComponent(match.split('=')[1]) : null;
}

export const withCredentialsInterceptor: HttpInterceptorFn = (reqx, next) => {
  const injector = inject(Injector);

  const applyCredentials: (request: HttpRequest<any>) => HttpRequest<any> = (request) => {

    if (!request.url.startsWith(environment.apiUrl)) {
      return request;
    }

    let credReq = request.clone({ withCredentials: true });
    const token = readCookie(document, XSRF_COOKIE);

    if (token && !credReq.headers.has(XSRF_HEADER)) {
      credReq = credReq.clone({ setHeaders: { [XSRF_HEADER]: token } });
    }

    return credReq;
  }

  const refreshCredentials: (error: any, next: HttpHandlerFn, httpRequest: HttpRequest<any>) => Observable<HttpEvent<any>> = (error, next, req) => {
    const originalError: Observable<any> = throwError(error);

    if (!(error instanceof HttpErrorResponse && error.status === 401)) {
      return originalError;
    }

    if (location.pathname.includes(AppRoutes.login)) {
      return originalError;
    }

    const authService = injector.get(AuthService);
    authService.redirectToSSOLogin();

    return originalError;
  }

  return next(applyCredentials(reqx)).pipe(
    catchError(error => refreshCredentials(error, next, reqx))
  );
};
